import axios from 'axios'
import { InstantPayFeeConfig, InstantPayFeePayer, InstantPayFeeTier, InstantPayFeeTierKind, RecentInstantPayPayout } from '@numeo/types'

export { InstantPayFeePayer }
export type { InstantPayFeeConfig, InstantPayFeeTier, InstantPayFeeTierKind, RecentInstantPayPayout }

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export const instantPayFeeApi = {
    /** GET the platform-wide fee schedule (null when unset — the legacy 0.95% clamp applies). */
    getConfig: async (): Promise<InstantPayFeeConfig | null> => {
        const res = await axios.get<Envelope<InstantPayFeeConfig | null>>('/gluon/config/instant-pay-fee')
        return res.data.data ?? null
    },

    /** PUT the fee schedule (staff-only; validated server-side). Returns the normalized config. */
    setConfig: async (config: InstantPayFeeConfig): Promise<InstantPayFeeConfig> => {
        const res = await axios.put<Envelope<InstantPayFeeConfig>>('/gluon/config/instant-pay-fee', config)
        return res.data.data
    },

    /** GET the most recent successful payouts across all carriers (staff view). */
    getRecentPayouts: async (limit = 100): Promise<RecentInstantPayPayout[]> => {
        const res = await axios.get<Envelope<RecentInstantPayPayout[]>>('/gluon/instant-pay/payouts/v1', { params: { limit } })
        return res.data.data ?? []
    },
}
